export class RedirectActionSettings {
    constructor() {
        this.context = undefined;
    }
}
